import styled from "@emotion/styled";
import { StyleguideSavioColors } from "../../../configuration/themeSettings";
import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";

export const StyledDialogTitle = styled(DialogTitle, {
    label: "AppBasketUpload-DialogCreateNewCart",
})(({ theme: Theme }) => ({
    backgroundColor: StyleguideSavioColors.mainBlue,
    color: StyleguideSavioColors.white,
    textTransform: "uppercase",
    marginTop: "15px",
    marginLeft: "15px",
    marginRight: "15px",
    padding: "4px 6px",
    borderRadius: "2px",
}));


export const StyledBoxDialogTitle = styled(Box, {
    label: "AppBasketUpload-BoxDialogCreateNewBasket",
})(({ theme: Theme }) => ({
    alignItems: "center", display: "flex"
}));

export const StyledDialogContentText = styled(Box, {
    label: "AppBasketUpload-StyledDialogContentText",
})(({ theme: Theme }) => ({
   color: StyleguideSavioColors.text.black,
}));

export const DialogContentStyled = styled(DialogContent, {
    label: "dialog-content-styled",
})(({ theme }) => ({
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: '20px !important',

}));
